module.exports = __webpack_public_path__ + "static/media/norge.4c4b8a19.jpg";